module.exports = __webpack_public_path__ + "static/img/1033_big.5d22128.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1033_big.png
// module id = 3lh3
// module chunks = 1